import { GeotiffRender } from '../utils/renderGeotiffRaster';

export interface FieldClickEventArgs {
  field: Field;
  layer?: RasterDocument | null;
  render?: GeotiffRender | null;
}

export { default as RootMap } from './RootMap';
export { default as FarmMap } from './FarmMap';
export { default as FieldOverlay } from './FieldOverlay';
export { default as ColorRasterOverlay } from './ColorRasterOverlay';
export { default as GoogleTileLayer } from './GoogleTileLayer';
export { default as BinLegend } from './BinLegend';
export { default as LinkButton } from './LinkButton';
export { default as LinkListItem } from './LinkListItem';
export { default as PlaceInput } from './PlaceInput';
export { default as EditablePolygon } from './EditablePolygon';
export { default as SceneTimeline } from './SceneTimeline';
export { default as UploadKmzDialog } from './UploadKmzDialog';
export { default as EditBinsDialog } from './EditBinsDialog';
export { default as HistogramChart } from './HistogramChart';
export { default as RasterMapReference } from './RasterMapReference';
export { default as InviteDialog } from './InviteDialog';
export { default as HistogramRanges } from './HistogramRanges';
export { default as SelectLayerDialog } from './SelectLayerDialog';
export { default as DocumentCard } from './DocumentCard';
export { default as DocumentGrid } from './DocumentGrid';
export { default as BaseMap } from './BaseMap';
export { default as TrackingChart } from './TrackingChart';
export { default as GeotiffOverlay } from './GeotiffOverlay';
export { default as AlertDialog } from './AlertDialog';
export { default as NdviRange } from './NdviRange';



// WEBPACK FOOTER //
// ./src/components/index.ts